/** @jsxImportSource @emotion/react */
import React from 'react';
import colorPalette from '../colorPalette';
import styled from '@emotion/styled';
import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

const PrvFormGroup = styled.div`
  display: flex;
`;

const PrvInputGroup = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const PrvIcon = styled(Icon)`
  position: relative;
  margin-left: -3rem;
  margin-right: 1em;
  padding-right: 0.25em;
`;

const PrvSelect = ({ large = false, defaultValue = undefined, onChange, labelText, children }) => {
  const selectClassName = `bp5-input${large ? ' bp5-large' : ''}`;

  return (
    <PrvFormGroup className='bp5-form-group'>
      <label className='bp5-label'>{labelText}</label>
      <PrvInputGroup>
        <select
          style={{ flex: 1 }}
          className={selectClassName}
          defaultValue={defaultValue}
          onChange={event => onChange(event)}
        >
          {children}
        </select>
        <PrvIcon icon={IconNames.CHEVRON_DOWN} />
      </PrvInputGroup>
    </PrvFormGroup>
  );
};

export const Select = styled(PrvSelect)`
  width: 100%;
`;

export const Option = styled.option`
  background-color: ${colorPalette.DARK_GRAY2};
`;
